module.exports = __webpack_public_path__ + "assets/img/favicon/ms-icon-70x70.c02164c92de529f87cf5a051b989948c.png";